import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27722 27320"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974584642752">
        <path
          d="M13156 7368c796-447 1810-172 2263 614 453 787 174 1789-622 2236-797 448-1810 172-2263-614-453-788-174-1788 622-2236zm14285-6139c-333-577-894-952-1581-1055-2337-351-6646 2785-9662 5293-1227-799-2852-907-4217-140-15 8-28 18-43 27C8741 2807 4230-338 1852 30 1166 136 625 491 289 1057c-397 671-385 1443 37 2175 1149 1996 5979 3978 9627 5235-64 773 97 1573 514 2298 418 725 1032 1271 1737 1610-769 3740-1514 8855-364 10850 421 731 1087 1137 1875 1143 662 4 1248-274 1691-803 1536-1832 1104-7267 522-11284 15-7 30-14 44-22 1366-767 2102-2202 2035-3652 3724-1278 8654-3335 9544-5497 261-636 222-1304-110-1881zM21790 24024c-2-5-6-8-8-13 2 16 5 37 11 64 0-19-3-35-3-51zM21793 24384c0-30-6-48-3-88-13 34-16 77-6 117 4-8 6-19 9-29zM21806 24125v-5c-5-16-8-26-13-45 2 19 8 32 13 50zM8671 27301c13 0 26 3 40 6 24 2 50 5 77 8 3 2 8 2 10 2 89 6 144 3-127-16z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
